<template>
    <CRow>
        <CCol>
            <CCard class="store-card">
                <CCardHeader>
                    <strong>Создание</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CInput
                            v-model="entity.title"
                            label="Название"
                            placeholder="Введите название"
                        />
                        <CInput
                            v-model="entity.code"
                            label="Код"
                            placeholder="Введите код"
                        />
                        <CInput
                            v-model="entity.short_name"
                            label="Короткое название"
                            placeholder="Введите короткое название"
                        />
                        <CInput
                            v-model="entity.legal_entity"
                            label="Юр. лицо"
                            placeholder="ООО…"
                        />
                        <CInput
                            v-model="entity.alias"
                            label="Алиас"
                            placeholder="Введите алиас"
                        />
                        <CTextarea
                            v-model="entity.description"
                            label="Краткое описание"
                            placeholder="Укажите краткое описание (не более 255 символов)"
                        />
                        <CTextarea
                            v-model="entity.synonyms"
                            label="Синонимы"
                            placeholder="Укажите синонимы для поиска" 
                        />
                        <CInputFile
                            ref="picture"
                            label="Изображение сервиса (мобильное приложение)"
                            horizontal
                            @change="selectPicture"
                        />
                        <CInputFile
                            ref="picture"
                            label="Изображение для поиска"
                            horizontal
                            @change="selectSquarePicture"
                        />
                        <br><br>
                        <CInputFile
                            ref="picture"
                            label="Изображение для десктопа (внутри сервиса)"
                            horizontal
                            @change="selectDesktopPicture"
                        />
                        <CInputFile
                            ref="picture"
                            label="Изображение для десктопа (список)"
                            horizontal
                            @change="selectDesktopPictureInList"
                        />
                        <CInputFile
                            ref="picture"
                            label="Изображение для популярного"
                            horizontal
                            @change="selectPopularPicture"
                        />
                        <CInputFile
                            ref="picture"
                            label="Изображение для описания"
                            horizontal
                            @change="selectDescriptionPicture"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Мелкая плитка товаров
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.small_cards"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Страница категорий
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.categories_page"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать изображение для описания
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.show_description_picture"
                                />
                            </CCol>
                        </CRow>
                        <CInput v-model="entity.phone" label="Телефон" />
                        <CInput
                            v-model="entity.open_at"
                            label="Открывается в"
                        />
                        <CInput
                            v-model="entity.close_at"
                            label="Закрывается в"
                        />

                        <CInput
                            v-model="entity.min_price"
                            label="Минимальный заказ"
                        />

                        <CInput
                            v-model="entity.min_price_pickup"
                            label="Минимальная сумма для самовывоза"
                        />

                        <CInput
                            v-model.number="entity.weight_limit"
                            label="Ограничение по весу (грамм)" />
                        <CInput
                            v-if="entity.weight_limit && entity.weight_limit > 0"
                            v-model="entity.weight_limit_description"
                            label="Сообщение о превышении веса" />

                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="entity.delay_time_hour"
                                    label="Время, необходимое на выполнение заказа (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="entity.delay_time"
                                    label="Время, необходимое на выполнение заказа (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="entity.delivery_time_hour"
                                    label="Время доставки (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="entity.delivery_time"
                                    label="Время доставки (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CInput
                                    v-model="entity.max_delivery_time_hour"
                                    label="Максимальное время доставки (часы)"
                                    placeholder="часы"
                                />
                            </CCol>
                            <CCol>
                                <CInput
                                    v-model="entity.max_delivery_time"
                                    label="Максимальное время доставки (минуты)"
                                    placeholder="минуты"
                                />
                            </CCol>
                        </CRow>
                        <CRow><CCol tag="label" class="col-form-label">Лейблы</CCol></CRow>
                        <CRow style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Новый сервис
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.is_new_label" 
                                />
                            </CCol>
                        </CRow>
                        <CRow style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Веган
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.vegan_label" 
                                />
                            </CCol>
                        </CRow>
                        <CRow style="margin-left: 50px">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Проверено МИРСИТИ
                            </CCol>
                            <CCol>
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.verified_mircity_label" 
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Рекламный партнер
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.is_advertisement"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Не показывать закрытым
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.not_close_service"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Убрать применение промокода
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.hide_promocode"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Отключить применение тарифов по зонам</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.delivery_zone_disabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { xssRegEx } from '@/utils/rules';
    import { BUSINESS_LABEL } from '@/utils/servicesLabel'

    export default {
        name: 'EntityCreate',

        data() {
            return {
                schedule: undefined,
                entity: {
                    service_label: '',
                    code: '',
                    title: '',
                    short_name: '',
                    legal_entity: '',
                    alias: '',
                    description: '',
                    synonyms: '',
                    picture: '',
                    square_picture: '',
                    desktop_picture: '',
                    desktop_picture_list: '',
                    popular_picture: '',
                    description_picture: '',
                    small_cards: false,
                    categories_page: false,
                    show_description_picture: false,
                    extended_schedule: false,
                    open_at: '0',
                    close_at: '0',
                    min_price: 0,
                    min_price_pickup: 0,
                    weight_limit: 0,
                    weight_limit_description: '',
                    phone: '',
                    delay_time: 0,
                    delay_time_hour: 0,
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    max_delivery_time_hour: 0,
                    max_delivery_time: 0,
                    delivery_zone_disabled: false,
                    enabled: true,
                    is_advertisement: true,
                    is_new_label: false,
                    vegan_label: false,
                    verified_mircity_label: false,
                    not_close_service: false,
                    cart_button_title: null,
                    cart_button_link: null,
                },
                selectedPicture: null,
                selectedSquarePicture: null,
                selectedDesktopPicture: null,
                selectedDesktopPictureInList: null,
                selectedPopularPicture: null,
                selectedDescriptionPicture: null,
            };
        },
        mounted() {

        },

        methods: {
            setSchedule(schedule){
                this.schedule = schedule;
            },
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
            selectSquarePicture(FileList) {
                this.selectedSquarePicture = FileList[0];
            },

            selectDesktopPicture(FileList) {
                this.selectedDesktopPicture = FileList[0];
            },
            selectDesktopPictureInList(FileList) {
                this.selectedDesktopPictureInList = FileList[0];
            },

            selectPopularPicture(FileList) {
                this.selectedPopularPicture = FileList[0];
            },

            selectDescriptionPicture(FileList) {
                this.selectedDescriptionPicture = FileList[0];
            },

            async create() {
                if (!this.entity.title) {
                    this.$root.$emit('showError', 'Укажите название сервиса.');
                    return;
                }
                if (!this.entity.description) {
                    this.$root.$emit('showError', 'Укажите краткое описание сервиса.');
                    return;
                }
                if (xssRegEx.test(this.entity.description)) {
                    this.$root.$emit('showError', 'Описание содержит недопустимые символы.')
                    return
                }
                if (!this.selectedPicture) {
                    this.$root.$emit('showError', 'Выберите картинку сервиса.');
                    return;
                }
                if (!this.entity.phone) {
                    this.$root.$emit('showError', 'Укажите номер телефона сервиса.');
                    return;
                }

                try {
                    let formData = new FormData();

                    if (this.selectedSquarePicture) {
                        formData.append('file', this.selectedSquarePicture);
                        const squarePictureName = await Vue.axios.post('/files/upload', formData);
                        this.entity.square_picture = squarePictureName.data.filename;
                    }

                    if (this.selectedDesktopPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedDesktopPicture);
                        const desktopPictureName = await Vue.axios.post('/files/upload', formData);
                        this.entity.desktop_picture = desktopPictureName.data.filename;
                    }

                    if (this.selectedDesktopPictureInList) {
                        formData = new FormData();
                        formData.append('file', this.selectedDesktopPictureInList);
                        const desktopPictureName = await Vue.axios.post('/files/upload', formData);
                        this.entity.desktop_picture_list = desktopPictureName.data.filename;
                    }

                    if (this.selectedPopularPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedPopularPicture);
                        const popularPictureName = await Vue.axios.post('/files/upload', formData);
                        this.entity.popular_picture = popularPictureName.data.filename;
                    }

                    if (this.selectedDescriptionPicture) {
                        formData = new FormData();
                        formData.append('file', this.selectedDescriptionPicture);
                        const popularPictureName = await Vue.axios.post('/files/upload', formData);
                        this.entity.description_picture = popularPictureName.data.filename;
                    }

                    formData = new FormData();
                    formData.append('file', this.selectedPicture);

                    const uploadPicture = await Vue.axios.post('/files/upload', formData);
                    this.entity.picture = uploadPicture.data.filename;
                    this.entity.schedule = this.schedule;

                    const newEntity = await Vue.axios.post(`/entities/${this.$route.params.code}/create`, this.entity);

                    this.$router.push({
                        path: `/entities/${this.$route.params.code}/${newEntity.data.id}`,
                    });
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка создания сервиса.');
                }
            },

            goBack() {
                this.$router.push({ path: `/entities/${this.$route.params.code}/${this.$route.params.id}` });
            },
        },
    };
</script>
